import clsx from 'clsx';
import styles from './Data2.module.scss';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  label: string;
  align?: 'center';
  addon?: ReactNode;
  contained?: boolean;
}

export function Data2(props: Props) {
  const rootClassName = clsx(
    styles['root'],
    props.align && styles[`align-${props.align}`],
    props.contained && styles[`contained`],
  );
  return (
    <div className={rootClassName}>
      <div className={styles['top']}>
        <span className={styles['label']}>{props.label}</span>
        {props.addon && <span>{props.addon}</span>}
      </div>
      <div className={styles['content']}>{props.children}</div>
    </div>
  );
}
